export const DOCUMENT_FOCUSABLE_SELECTOR = [
  'a[href]',
  'button:not([disabled])',
  'input:not([disabled])',
  'select:not([disabled])',
  'textarea:not([disabled])',
  '[tabindex]:not([tabindex="-1"])',
].join(',');

export const getDocumentFocusableElements = (root: Document = document): HTMLElement[] =>
  Array.from(root.querySelectorAll<HTMLElement>(DOCUMENT_FOCUSABLE_SELECTOR)).filter(
    (element) => !element.hasAttribute('hidden') && element.getClientRects().length > 0,
  );

export const moveFocusFromTrigger = (
  trigger: HTMLElement | null,
  backward: boolean,
  root: Document = document,
): void => {
  const focusableElements = getDocumentFocusableElements(root);
  const triggerIndex = trigger === null ? -1 : focusableElements.indexOf(trigger);
  const target = focusableElements[triggerIndex + (backward ? -1 : 1)];

  (target ?? trigger)?.focus();
};
